import React from 'react';
import Chest from "../assets/img/chest-404.png";
import Helmet from '../components/Helmet';

const PageNotFound = () => {
  return (
    <div id="page-404" className="page fade-onload">
        <Helmet
            title="Captain Candy"
            metaDesc="Our stores can be found in various cities in Europe. But beware! Not every shop with a wooden interior is a guarantee of Captain Candy quality. Always look only for the original Captain Candy stores, which are a safe bet. You can find a list of our stores on our website."
        />
        <div className="container-custom">
            <div className="visible-xs">
                <img src={Chest} alt="404" className="chest" />
            </div>
            <div className="hidden-xs">
                <div className="chest"></div>
            </div>
            <div className="content">
                <h1 className="page-heading fade-onload">
                Page not found
                </h1>
                <p>
                    This chest is&nbsp;empty. <br /> The site you are looking for can not appear on&nbsp;the maps. <br /> Continue to&nbsp;homepage.
                </p>
                
                <div className="btn-wrap" style={{ marginTop: "60px" }}>
                    <a href="/" className="btn btn-primary">Homepage</a>
                </div>
            </div>
        </div>
    </div>
  )
}

export default PageNotFound;
